var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',_vm._l((_vm.portals),function(portal){return _c('div',{key:portal.id},[_c('portal-card',{attrs:{"url":portal.url,"title":portal.title,"url_c":portal.url_c,"desc":portal.desc,"aces":portal.aces}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }